export const ROUTES = [
  {
    name: 'Home',
    path: '/',
    req: true
  },
  {
    name: 'Explore',
    path: '/explore'
  },
  {
    name: 'Notifications',
    path: '/notifications'
  },
  {
    name: 'Messages',
    path: '/messages'
  },
  {
    name: 'Bookmarks',
    path: '/bookmarks'
  },
  {
    name: 'Lists',
    path: '/lists'
  }
]

export const moreMenuItems = [
  {
    name: 'Topics',
    icon: 'topics'
  },
  {
    name: 'Moments',
    icon: 'moments'
  },
  {
    name: 'Help Center',
    icon: 'help'
  },
  {
    name: 'Settings & privacy',
    icon: 'settings'
  },
]